import React from "react";
import { Box, Skeleton, Stack, Typography } from "@mui/material";

interface PortfolioSummaryBarProps {
  totalStudies: number;
  onTrack: number;
  needsAttention: number;
  totalEnrolled: number;
  currentlyActive: number;
  loading?: boolean;
}

function StatItem({ label, value, color, loading }: {
  label: string;
  value: number;
  color?: string;
  loading?: boolean;
}) {
  return (
    <Box sx={{ textAlign: "center", minWidth: 100 }}>
      <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.7rem", textTransform: "uppercase", letterSpacing: 0.5 }}>
        {label}
      </Typography>
      {loading ? (
        <Skeleton variant="text" width={40} height={36} sx={{ mx: "auto" }} />
      ) : (
        <Typography variant="h5" fontWeight={700} color={color || "text.primary"}>
          {value.toLocaleString()}
        </Typography>
      )}
    </Box>
  );
}

const PortfolioSummaryBar: React.FC<PortfolioSummaryBarProps> = ({
  totalStudies,
  onTrack,
  needsAttention,
  totalEnrolled,
  currentlyActive,
  loading,
}) => {
  return (
    <Box
      sx={{
        height: 80,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "grey.50",
        borderRadius: 3,
        px: 3,
        mb: 2,
        border: "1px solid",
        borderColor: "grey.200",
      }}
    >
      <Stack
        direction="row"
        spacing={4}
        divider={<Box sx={{ width: 1, bgcolor: "grey.300", alignSelf: "stretch", my: 1 }} />}
        alignItems="center"
      >
        <StatItem label="Active Studies" value={totalStudies} loading={loading} />
        <StatItem label="On Track" value={onTrack} color="success.main" loading={loading} />
        <StatItem label="Needs Attention" value={needsAttention} color="error.main" loading={loading} />
        <StatItem label="Total Enrolled" value={totalEnrolled} loading={loading} />
        <StatItem label="Active This Week" value={currentlyActive} color="secondary.main" loading={loading} />
      </Stack>
    </Box>
  );
};

export default PortfolioSummaryBar;
